<template>
  <div v-if="results.length" class="result-list">
    <div class="result-list__summary">
      <span>共生成 {{ totalIcons }} 个 ICO 文件</span>
      <button class="btn btn-primary" @click="$emit('download-zip')">
        <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
          <polyline points="7 10 12 15 17 10" />
          <line x1="12" y1="15" x2="12" y2="3" />
        </svg>
        下载全部 (ZIP)
      </button>
    </div>
    <ul class="result-list__items">
      <li v-for="r in results" :key="r.id" class="result-item">
        <div class="result-item__head">
          <div class="result-item__name" :title="r.name">{{ r.name }}</div>
          <span class="result-item__count">{{ r.blobs.length }} 个尺寸</span>
        </div>
        <div class="result-item__sizes">
          <button
            v-for="b in r.blobs"
            :key="b.size"
            class="size-pill"
            @click="$emit('download', b.blob, b.filename)"
            :title="`下载 ${b.filename}`"
          >
            <span class="size-pill__px">{{ b.size }}</span>
            <span class="size-pill__unit">px</span>
            <svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
              <polyline points="7 10 12 15 17 10" />
              <line x1="12" y1="15" x2="12" y2="3" />
            </svg>
          </button>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'ResultList',
  props: {
    results: { type: Array, required: true },
  },
  emits: ['download', 'download-zip'],
  computed: {
    totalIcons() {
      return this.results.reduce((sum, r) => sum + r.blobs.length, 0);
    },
  },
};
</script>

<style lang="less" scoped>
.result-list {
  &__summary {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 12px;
    font-size: 13px;
    color: var(--text-dim);
  }

  &__items {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
}

.result-item {
  background: var(--bg-elev-2);
  border: 1px solid var(--border);
  border-radius: 6px;
  padding: 12px 14px;

  &__head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
  }

  &__name {
    font-size: 14px;
    color: var(--text);
    font-weight: 500;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &__count {
    font-size: 12px;
    color: var(--text-dim);
  }

  &__sizes {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }
}

.size-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border: 1px solid var(--border);
  background: var(--bg-elev);
  border-radius: 999px;
  font-size: 12px;
  color: var(--text);
  cursor: pointer;
  transition: border-color 0.15s ease, color 0.15s ease, background-color 0.15s ease;

  &:hover:not(:disabled) {
    border-color: var(--accent);
    color: var(--accent);
    background: rgba(255, 122, 26, 0.12);
  }

  &__px {
    font-weight: 600;
  }

  &__unit {
    color: var(--text-dim);
  }
}
</style>
